var map = {
	"./ticket-pattern-0.svg": "fd8e",
	"./ticket-pattern-1.svg": "4f50",
	"./ticket-pattern-2-full.svg": "d599",
	"./ticket-pattern-2.svg": "d017"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dfa";